import { asType } from '@sparky/framework'
import { CONNECTED_PLATFORMS, APP_ID_CASB_NGFW } from '../../common/constants/GlobalConstants'
import { ActivationManifest, PrimaryAppIds } from '../renderer'

export default asType<ActivationManifest>({
  activation_id: 'ng_casb',
  description: 'Next-Generation CASB for Prisma Access and NGFW',
  primary_app_id: PrimaryAppIds.NG_CASB,
  flags: {
    hash_required: true,
    cdl_required: false,
    amend_license: true,
    show_purchased_size_as_qty: true,
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.DefaultActivateScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.ScreenHeader',
            props: {
              title: 'Activate Next Generation CASB',
              subTitle: ''
            }
          },
          {
            key: 'activation-form',
            component: 'activation.DefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'default-dropdown-component',
                  component: 'activation.DefaultActivationCommonDropdowns',
                  props: {
                    group: 1, // used for grouping elemenets/children to apply common properties such as style.
                    children: [
                      {
                        key: 'default-tsg-component',
                        component: 'activation.TSGDropDown',
                        props: {
                          create_new: true,
                          showAllTSG: true,
                          display: {
                            errorMessage: 'Select TSG to proceed activation',
                            toolTipMessage: 'Select the TSG where the license needs to be provisioned',
                            subTitle: 'The tenant where the license will be activated'
                          },
                          dropDownProps: {
                            required: true,
                            addNewValue: true,
                            triggerValidationOnChange: true,
                            addNewProps: {
                              conditionValue: 'ADD_NEW',
                              updatedValue: '',
                              createValue: '[Create New]'
                            }
                          },
                          size: {
                            height: 32,
                            width: 300
                          },
                          passByProps: {
                            enableSearch: true,
                            label: 'Tenant',
                            dataMetrics: 'default-tsg-component',
                            dataTestId: 'tsg-activation-screen',
                            placeholder: 'Select Tenant / Create New',
                            menuStyle: { width: 300 },
                          }
                        }
                      },
                      {
                        key: 'default-csp-component',
                        component: 'activation.CSPDropDownWrapper',
                        props: {
                          display: {
                            subTitle: 'Customer support account for this tenant'
                          },
                          passByProps: {
                            menuStyle: { width: 300 },
                          }
                        }
                      },
                      {
                        key: 'default-region-component',
                        component: 'activation.RegionDropDown',
                        props: {
                          header: true,
                          display: {
                            subTitle: 'Deployment region and where your data logs are stored'
                          },
                          passByProps: {
                            menuStyle: { width: 300 },
                          }
                        }
                      }
                    ]
                  },
                },
                {
                  key: 'default-divider-component',
                  component: 'activation.DividerLine',
                  props: {}
                },
                {
                  key: 'default-license-details-component',
                  component: 'activation.DefaultPrimaryLicenseDetails',
                  props: {
                    group: 1,
                  }
                },
                {
                  key: 'default-add-on-licenses',
                  component: 'activation.DefaultAddonLicenses',
                  props: {
                    group: 1,
                  }
                },
                {
                  key: 'casbx-platforms',
                  component: 'activation.PlatformBanner',
                  props: {
                    title: 'Can be used on',
                    connectedPlatforms: CONNECTED_PLATFORMS[PrimaryAppIds.NG_CASB],
                    defaultPlatformId: APP_ID_CASB_NGFW,
                    infoMessage: 'Thank you for activating NG CASB! If Firewalls need to be associated, please do so in the Device Association Tab.',
                    group: 2,
                  }
                },
                {
                  key: 'instance-table',
                  component: 'activation.InstanceTable',
                  props: {
                    group: 2,
                    title: 'Active Subscriptions',
                    subTitle: ''
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                },
              ],
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
